/*
 *  I01EVAECSQUALI3Calcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 16:13:25 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchRLogementCompoEHPAD, fetchQualitelWithDTU } from '@batical/data/src'
import i18n from '@batical/i18n'
import { I01EVAECSQUALI3_State } from '@batical/types/src'

//TODO IF REQUIREDimport {} from '@batical/types/src';
function I01EVAECSQUALI3_docalcul(state: I01EVAECSQUALI3_State) {
  state.res_totalLogementStandard = 0
  state.res_totalLogementStandard += state.in_t11 * fetchRLogementCompoEHPAD('T11').nbStandard
  state.res_totalLogementStandard += state.in_t21 * fetchRLogementCompoEHPAD('T21').nbStandard
  state.res_totalLogementStandard += state.in_t31 * fetchRLogementCompoEHPAD('T31').nbStandard
  state.res_totalLogementStandard += state.in_t32 * fetchRLogementCompoEHPAD('T32').nbStandard
  state.res_totalLogementStandard += state.in_t41 * fetchRLogementCompoEHPAD('T41').nbStandard
  state.res_totalLogementStandard += state.in_t42 * fetchRLogementCompoEHPAD('T42').nbStandard

  const squali = fetchQualitelWithDTU(state.res_totalLogementStandard)
  if (squali != null) {
    state.res_s1 = squali.s1
    state.res_s2 = squali.s2
    state.res_s3 = squali.s3

    if (state.in_typeCalcul === 1) {
      var tempCalc = state.in_t11
      tempCalc += state.in_t21
      tempCalc += state.in_t31
      tempCalc += state.in_t32
      tempCalc += state.in_t41
      tempCalc += state.in_t42
      var debitBrut = tempCalc
      var debitTotal = tempCalc * 0.133
      //vasque
      tempCalc = 0
      tempCalc += state.in_t11
      tempCalc += state.in_t21
      tempCalc += state.in_t31
      tempCalc += state.in_t32 * 2
      tempCalc += state.in_t41
      tempCalc += state.in_t42 * 2
      debitBrut += tempCalc
      debitTotal += tempCalc * 0.133
      //douche
      tempCalc = 0
      tempCalc += state.in_t11
      tempCalc += state.in_t21
      tempCalc += state.in_t32
      tempCalc += state.in_t42
      debitBrut += tempCalc
      debitTotal += tempCalc * 0.133
      //baignoe
      tempCalc = 0
      tempCalc += state.in_t31
      tempCalc += state.in_t32
      tempCalc += state.in_t41
      tempCalc += state.in_t42
      debitBrut += tempCalc
      debitTotal += tempCalc * 0.33
      state.res_simuDTU = 0.8 / Math.sqrt(debitBrut - 1)
      state.res_effEchangeur = (state.in_tempBouclage - state.in_tempFroide) / (state.in_tempStackage - state.in_tempRetour)
      state.res_debitDTU = debitTotal * state.res_simuDTU * 60
      state.res_puissMiniQualitel = state.res_totalLogementStandard * state.res_s1 * 21
    } else {
      state.res_simuDTU = 0.0
      state.res_effEchangeur = 0.0
      state.res_debitDTU = 0.0
      state.res_puissMiniQualitel = 0.0
    }
    let limiteSemi = 20 * state.res_totalLogementStandard
    let limiteSemiAcc = 150 * state.res_s3 * state.res_totalLogementStandard
    if (state.in_typeCalcul === 1) {
      limiteSemi = limiteSemi * state.res_effEchangeur
      limiteSemiAcc = limiteSemiAcc * state.res_effEchangeur
    }
    if (state.in_typeCalcul === 0 && state.in_volume === 0) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI3_p_inst')
      state.res_puissance = state.res_puissance = state.res_totalLogementStandard * state.res_s1 * 21
    } else if (state.in_volume < limiteSemi) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_semi')
      //=calcul!D14*(0,25*calcul!C19-1,05*calcul!B19)*C30/calcul!D14+21*calcul!B19*calcul!D14
      state.res_puissance =
        (state.res_totalLogementStandard * (0.25 * state.res_s2 - 1.05 * state.res_s1) * state.in_volume) /
          state.res_totalLogementStandard +
        21 * state.res_totalLogementStandard * state.res_s1
      if (state.in_typeCalcul === 1) {
        state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_semi_prim')
        // state.res_puissance = state.res_puissance * state.res_effEchangeur;
        state.res_puissance = Math.min(state.res_puissance * state.res_effEchangeur, state.res_puissMiniQualitel)
      }
      //=calcul!D14*(0,25*calcul!C19-1,05*calcul!B19)*C30/calcul!D14+21*calcul!B19*calcul!D14
    } else if (state.in_volume < limiteSemiAcc) {
      //=(((0,535*calcul!B19+0,214-2,5*calcul!C19)*(C34/calcul!D14-20)/(75*calcul!D19-10))+5*calcul!C19)*calcul!D14
      state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_semiacc')
      state.res_puissance =
        (((0.535 * state.res_s1 + 0.214 - 2.5 * state.res_s2) * (state.in_volume / state.res_totalLogementStandard - 20)) /
          (75 * state.res_s3 - 10) +
          5 * state.res_s2) *
        state.res_totalLogementStandard
      if (state.in_typeCalcul === 1) {
        state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_semiacc_prim')
        state.res_puissance = state.res_puissance * state.res_effEchangeur
      }
    } else {
      //=calcul!D14*(7,14*C38/calcul!D14+428)/1000
      state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_acc')
      state.res_puissance = (state.res_totalLogementStandard * ((7.14 * state.in_volume) / state.res_totalLogementStandard + 428)) / 1000
      if (state.in_typeCalcul === 1) {
        state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_acc_prim')
        state.res_puissance = state.res_puissance * state.res_effEchangeur
      }
    }
    if (state.in_typeCalcul === 1 && state.in_volume === 0) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI3_couple_inst')
    }
  } else {
    state.res_s1 = 0
    state.res_s2 = 0
    state.res_s3 = 0
    state.res_simuDTU = 0.0
    state.res_effEchangeur = 0.0
    state.res_debitDTU = 0.0
    state.res_puissMiniQualitel = 0.0
    state.res_puissance = 0.0
    state.res_modePuissance = ''
  }
  state.invalidated = false
  return state
}

export default I01EVAECSQUALI3_docalcul
